import { z } from 'zod';

const dataSchema = z.object({
  production_lot: z.string(),
  farm_region: z.string(),
  chicken_dispatch_date: z.string(),
  plant_name: z.string(),
  production_date: z.string(),
  country: z.string(),
  country_code: z.string(),
  warehouse_exit_date: z.string(),
  plant_location: z.string(),
  id: z.number(),
});

export default dataSchema;
